module.exports = __webpack_public_path__ + "static/media/CHE.9adc9200.jpg";